// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QqIlRc{width:7px;height:7px;border-color:white;border-style:solid;border-width:1px 1px 0 0;transform:rotate(45deg);display:inline-block}.xronTp{transform:rotate(-135deg)}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `QqIlRc`,
	"left": `xronTp`
};
export default ___CSS_LOADER_EXPORT___;
